import { Country } from '../../enums/Country';
import { SettleAccountStatus } from '../../enums/SettleAccountStatus';
import { SettleAccount } from '../types/SettleAccount';

export class SettleAccountDetail implements SettleAccount {
    id?: number | undefined;

    bankCardName?: string | undefined;

    bankName?: string | undefined;

    bankCardNo?: string | undefined;

    branch?: string | undefined;

    bankAddress?: string | undefined;

    status: SettleAccountStatus = SettleAccountStatus.Default;

    cnapsCode?: string | undefined;

    swiftCode?: string | undefined;

    createTime?: string | undefined;

    country?: Country | undefined;

    settleAddress?: string | undefined;
}
